import React from 'react';

const markers = [
    { lat: 40.7128, lon: -74.0060, name: 'New York', imageUrl: 'https://placehold.co/100' },
    { lat: 40.7128, lon: -74.0060, name: 'New York', imageUrl: 'https://placehold.co/100' },
    { lat: 40.7128, lon: -74.0060, name: 'New York', imageUrl: 'https://placehold.co/100' },
    // Add more markers as needed
  ];



export default markers;